module.exports = __webpack_public_path__ + "img/9788949123387.0c016826.jpg";